export default "__VITE_ASSET__BaAtHUnO__"